import { useCallback } from 'react';

import { type DateDisplayFormat, formatDate as formatDateValue } from '@/services/dateFormat';

const useDateFormatter = () => {
    const formatDate = useCallback((value: string | number, format: string): string => {
        return formatDateValue(value, format as DateDisplayFormat);
    }, []);

    return { formatDate };
};

export { useDateFormatter };
